import * as angular from "angular";
import {IHttpService, IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";
import {SmsNotificationType} from "../enums/sms-notification.type";

export class MessagesRequestsService {

  /* @ngInject */
  constructor(private $messages, private $http: IHttpService, private apiConfig: ApiConfig,
              private $q: IQService, private splitService: SplitService, private MessagesAPI) {
  }

  // ******************************
  // External methods
  // ******************************

  sendText(payload) {
    const api = this.MessagesAPI.actions.send;
    return this.$$call(api, {}, payload, {}, undefined);
  }

  getTotals(from: string, to: string, isSent: boolean | undefined, notificationType: SmsNotificationType) {
    const api = this.MessagesAPI.actions.getTotals;
    return this.$$call(api, {from: from, to: to, isSent: isSent, notificationType: notificationType}, {}, {}, undefined);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  _sendResponseData(response) {
    return this.$q.resolve(response.data);
  }

  _sendError(response) {
    return this.$q.reject(response.data);
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options, messageId) {
    return this.$messages(messageId).$call(_apiCall, _params, _data, _options);
  }


}

angular
  .module('bringoz.admin.messages')
  .service('messagesRequestsService', MessagesRequestsService);
